export const regex = {
  phone: /^\+[0-9]{1,15}$/, // TODO: PhoneInput
  email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  IC: /^[0-9]{8}$/,
  DIC: new RegExp([
    "(^CZ[0-9]{8,10}$)|",// Česká republika
    "(^SK[0-9]{10}$)|",// Slovensko
    "(^BE0[0-9]{9}$)|",// Belgie
    "(^BY[0-9]{9}$)|",// Bělorusko
    "(^BA[0-9]{12,13}$)|",// Bosna a Hercegovina
    "(^BG[0-9]{9,10}$)|",// Bulharsko
    "(^DK[0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$)|",// Dánsko
    "(^EE[0-9]{9}$)|",// Estonsko
    "(^FI[0-9]{8}$)|",// Finsko
    "(^FR[0-9a-zA-Z]{11}$)|",// Francie
    "(^HR[0-9]{11}$)|",// Chorvatsko
    "(^IE[0-9]{7}[a-zA-Z]{1,2}$)|",// Irsko
    "(^IT[0-9]{11}$)|",// Itálie
    "(^LT[0-9]{9}|LT[0-9]{12}$)|",// Litva
    "(^LV[0-9]{11}$)|",// Lotyšsko
    "(^LU[0-9]{8}$)|",// Lucembursko
    "(^HU[0-9]{8}$)|",// Maďarsko
    "(^DE[0-9]{9}$)|",// Německo
    "(^NL[0-9a-zA-Z]{12}$)|",// Nizozemsko
    "(^NO[0-9]{9,11}$)|",// Norsko
    "(^PL[0-9]{10}$)|",// Polsko
    "(^PT[0-9]{9}$)|",// Portugalsko
    "(^ATU[0-9a-zA-Z]{8}$)|",// Rakousko
    "(^RO[0-9]{2,10}$)|",// Rumunsko
    "(^RU[0-9]{10,12}$)|",// Ruská federace
    "(^EL[0-9]{9}$)|",// Řecko
    "(^SI[0-9]{8}$)|",// Slovinsko
    "(^GB[0-9]{8,10}$)|",// Spojené království
    "(^RS[0-9]{9,13}$)|",// Srbsko
    "(^ES[0-9a-zA-Z]{9}$)|",// Španělsko
    "(^SE[0-9]{10}01$)|",// Švédsko
    "(^CH[0-9]{9,13}$)|",// Švýcarsko
    "(^UA[0-9]{10,12}$)",// Ukrajina
  ].join("")),
}
